import React, { useState, useEffect } from "react";
import { Card, Col, Row, Button, Spin, Typography, Input } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css";

const { Text } = Typography;

// Shared card component
const DiscoverCard = ({ title, message, isMobile, onClick }) => (
  <Card
    title={title}
    onClick={onClick}
    bordered={false}
    style={{ flex: 1, backgroundColor: "whitesmoke" }}
    className="card-hover-effect"
  >
    {message}
  </Card>
);

export const Discover1 = ({ setNewMessage }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const navigate = useNavigate();
  const location = useLocation();

  const handleCardClick = (message) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("question", message);
    navigate(`/?${searchParams.toString()}`);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Render a section with a title and a set of cards
  const renderSection = (title, items) => (
    <div style={{ margin: "5% 5% 0" }}>
      <h2>{title}</h2>
      <Row gutter={16} style={{ display: "flex", alignItems: "stretch" }}>
        {items.map((item, index) => (
          <Col
            key={index}
            xs={24}
            sm={12}
            md={8}
            lg={8}
            xl={8}
            style={{ display: "flex" }}
          >
            <DiscoverCard
              title={item.title}
              message={item.message}
              isMobile={isMobile}
              onClick={() => handleCardClick(item.message)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );

  return (
    <div
      style={{
        paddingTop: isMobile ? "20%" : "5%", // Adjust top padding here
        paddingBottom: isMobile ? "20%" : "15%", // Adjust bottom padding here
      }}
    >
      {renderSection("Explore Trending Screens", [
        {
          title: "High Flyer Stocks",
          message: "Companies trading near their 52-week high",
        },
        {
          title: "GPU Manufacturers",
          message:
            "Identify GPU manufacturers with 10% quarterly revenue growth and sort them by Market Capitalization",
        },
        {
          title: "Space exploration",
          message: "Top 5 Space exploration companies based on revenues",
        },
      ])}

      {/* Add other sections similarly */}
      {renderSection("Business Breakdown: In-Depth Analysis", [
        {
          title: "Microsoft Company Analysis",
          message: "Analyze the financials of Microsoft.",
        },
        {
          title: "Amazon news today",
          message: "What’s the news around Amazon today?",
        },
        {
          title: "Nvidia latest product launches",
          message: "What are the latest GPU launches by Nvidia?",
        },
      ])}

      {renderSection("Your DCF Valuation Hub", [
        {
          title: "Costco - Buy or not?",
          message: "Should I buy Costco today?",
        },
        {
          title: "Nvidia DCF",
          message: "What is the fair value of Nvidia?",
        },
        {
          title: "Meta value",
          message: "Is Meta fairly valued?",
        },
      ])}

      {renderSection("Compare & Contrast: Companies at a Glance", [
        {
          title: "AMD Vs Nvidia",
          message: "Compare AMD vs. Nvidia in terms of profit margins.",
        },
        {
          title: "Amazon Vs Walmart",
          message:
            "Compare Amazon vs. Walmart in terms of revenue growth and ROCE.",
        },
        {
          title: "Microsoft Vs Amazon",
          message: "Compare Microsoft and Amazon on Cloud business",
        },
      ])}

      {renderSection("Earnings Spotlight: Quick Call Summaries", [
        {
          title: "Tesla",
          message: "Analyze earning call of Tesla",
        },
        {
          title: "Apple",
          message: "Provide summary of Apple earning call",
        },
        {
          title: "Costco",
          message: "Provide earning transcript summary of Costco",
        },
      ])}

      {renderSection("Boost Your Market IQ", [
        {
          title: "Cigar-butt Investing",
          message: "What is Cigar butt investing?",
        },
        {
          title: "Buffet on Bitcoin",
          message: "What are Warren Buffet views on Bitcoin?",
        },
        {
          title: "ROCE",
          message: "What is ROCE and how is it calculated",
        },
      ])}
    </div>
  );
};

export default Discover1;
